import React, { SVGProps } from 'react'

import MeasurIcon from './MeasurIcon'

export default class IconInfo extends MeasurIcon<SVGProps<SVGSVGElement>> {
  render() {
    return (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...this.props}
      >
        <path
          d="M20.5002 36.6668C29.7049 36.6668 37.1668 29.2049 37.1668 20.0002C37.1668 10.7954 29.7049 3.3335 20.5002 3.3335C11.2954 3.3335 3.8335 10.7954 3.8335 20.0002C3.8335 29.2049 11.2954 36.6668 20.5002 36.6668Z"
          stroke="currentColor"
          strokeWidth={this.props.strokeWidth || '1.66667'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.5 26.6667V20"
          stroke="currentColor"
          strokeWidth={this.props.strokeWidth || '1.66667'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.5 13.3335H20.5167"
          stroke="currentColor"
          strokeWidth={this.props.strokeWidth || '1.66667'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}
